import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container, Typography, TextField,
  Button, Paper, CircularProgress, Box
} from '@mui/material';
import Editor from 'react-simple-wysiwyg';
import DashboardLayout from '../../Sidebar/DashboardLayout';
import axios from 'axios';
import './addEmailTemplate.css'; 

const ViewEmailTemplate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [template, setTemplate] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/email-templates/${id}`)
      .then((res) => setTemplate(res.data))
      .catch(() => setTemplate(null))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" mt={4}>
        <CircularProgress />
      </Box>
    );
  }

  if (!template) {
    return (
      <Box display="flex" justifyContent="center" mt={4}>
        <Typography variant="h6">Modèle introuvable.</Typography>
      </Box>
    );
  }

  return (
    <DashboardLayout>
      <Container maxWidth="md">
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h5">
            Consulter un modèle d'e-mail
          </Typography>
          <Button variant="outlined" onClick={() => navigate('/admin/email-templates')}>
            Retour
          </Button>
        </Box>

        <Paper elevation={3} className="add-email-template">
          <TextField
            label="Nom du modèle"
            name="nom"
            value={template.nom}
            fullWidth
            margin="normal"
            InputProps={{ readOnly: true }}
          />
          <TextField
            label="Sujet"
            name="sujet"
            value={template.sujet}
            fullWidth
            margin="normal"
            InputProps={{ readOnly: true }}
          />
          <TextField
            label="Type"
            name="type"
            value={template.type}
            fullWidth
            margin="normal"
            InputProps={{ readOnly: true }}
          />
          <Typography variant="subtitle1" gutterBottom>
            Contenu de l'e-mail :
          </Typography>

          <Paper variant="outlined" style={{ padding: '15px', backgroundColor: '#fdfdfd' }}>
            <div
              dangerouslySetInnerHTML={{ __html: template.contenu }}
              style={{ lineHeight: 1.6 }}
            />
          </Paper>

        </Paper>
      </Container>
    </DashboardLayout>
  );
};

export default ViewEmailTemplate;
